import { useEffect } from 'react';
import { useParams } from 'react-router';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';
import { useSeoContext } from '@sorare/core/src/contexts/seo';

import { Articles } from '#src/components/Articles/index.tsx';
import { Header } from '#src/components/Header/index.tsx';
import { useSection } from '#src/hooks/zendesk.ts';
import { categoryPath, sectionPath } from '#src/lib/path.ts';

const Section = () => {
  const { sectionId } = useParams();
  const { category, section, loaded } = useSection(sectionId);
  const { setPageMetadata } = useSeoContext();

  useEffect(() => {
    if (section) {
      setPageMetadata(section.name, { description: section.description });
    }
  }, [section, setPageMetadata]);

  if (!loaded) {
    return <LoadingIndicator fullHeight />;
  }

  if (!section || !category) {
    return null;
  }

  const sections = [
    {
      name: category.name,
      to: categoryPath(category),
    },
    {
      name: section.name,
      to: sectionPath(section),
    },
  ];

  return (
    <Vertical gap={3}>
      <Header sections={sections} />
      <Articles section={section} />
    </Vertical>
  );
};

export default Section;
